module.exports = __webpack_public_path__ + "static/media/bg_a.43d3b166.jpg";